import React, { useCallback } from 'react';
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { Box, Paper, Typography } from '@mui/material';

const initialNodes = [
  {
    id: '1',
    type: 'input',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Vorarbeit und Anlieferung
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#7c3aed',
              background: '#ede9fe',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              transcript
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            • PDF-Vorlage mit enthaltenen Elementen (visuell, ohne A11y-Features)<br/>
            • Strukturierte DOCX mit getaggten Elementen<br/>
            • Assets wie Icons
          </div>
        </div>
      )
    },
    position: { x: 0, y: 200 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '2',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Durchsicht und Feedback
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#0891b2',
              background: '#cffafe',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              le-tex
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            Durchsicht der Materialien und anschließende Aufwandseinschätzung
          </div>
        </div>
      )
    },
    position: { x: 520, y: 200 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '3',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Freigabe
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#7c3aed',
              background: '#ede9fe',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              transcript
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            Freigabe zur Entwicklung basierend auf Aufwandseinschätzung
          </div>
        </div>
      )
    },
    position: { x: 1040, y: 200 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '4',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Entwicklung Konverter
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#0891b2',
              background: '#cffafe',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              le-tex
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            Konvertierungspipeline:<br/>
            • DOCX → XML<br/>
            • XML → TeX<br/>
            • TeX → PDF
          </div>
          <a
            href="https://github.com/transcript-publishing/transpect/commits/ally/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '12px',
              color: '#0891b2',
              marginTop: '10px',
              display: 'inline-block',
              textDecoration: 'none'
            }}
          >
            Link: GitHub
          </a>
        </div>
      )
    },
    position: { x: 1560, y: 200 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '5',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Prüfung und Nacharbeit
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#7c3aed',
              background: '#ede9fe',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              transcript
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            • Prüfung der Ergebnisse<br/>
            • Zurückspielen offener Enden<br/>
            • z.B. Nachziehen von A11y-Features
          </div>
        </div>
      )
    },
    position: { x: 520, y: 550 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '6',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Makefile & Browserinterface
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#ea580c',
              background: '#ffedd5',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              Bei Bedarf
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            Änderungen wenn künftig Parameter beim Start einer Produktionspipeline mitgegeben werden müssen (z.B. Silbentrennung, Font, etc.)
          </div>
        </div>
      )
    },
    position: { x: 1040, y: 550 },
    style: {
      background: '#fffbeb',
      border: '2px solid #fde68a',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '7',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Automatische Tests
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#059669',
              background: '#d1fae5',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              Integration
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            Aufnahme der DOCX + Assets in die automatischen Tests
          </div>
        </div>
      )
    },
    position: { x: 0, y: 900 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '8',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Dokumentation
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#059669',
              background: '#d1fae5',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              Integration
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            Dokumentation im Mappinguide
          </div>
        </div>
      )
    },
    position: { x: 520, y: 900 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '9',
    type: 'output',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Zentrale DOCX-Verwaltung
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#059669',
              background: '#d1fae5',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              Integration
            </div>
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            Verwaltung der neuen Styles in zentraler DOCX
          </div>
        </div>
      )
    },
    position: { x: 1040, y: 900 },
    style: {
      background: '#f0fdf4',
      border: '2px solid #86efac',
      borderRadius: '12px',
      width: 320,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
];

const initialEdges = [
  {
    id: 'e1-2',
    source: '1',
    target: '2',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Materialien übergeben',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e2-3',
    source: '2',
    target: '3',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Aufwandseinschätzung',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e3-4',
    source: '3',
    target: '4',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Freigabe erteilt',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e4-5',
    source: '4',
    target: '5',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Konverter fertig',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e5-4',
    source: '5',
    target: '4',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#ef4444', strokeWidth: 2, strokeDasharray: '5,5' },
    label: 'Offene Enden',
    labelStyle: { fill: '#dc2626', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e4-6',
    source: '4',
    target: '6',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#f59e0b', strokeWidth: 2, strokeDasharray: '5,5' },
    label: 'Parameter nötig',
    labelStyle: { fill: '#d97706', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e5-7',
    source: '5',
    target: '7',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Prüfung OK',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e7-8',
    source: '7',
    target: '8',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 }
  },
  {
    id: 'e8-9',
    source: '8',
    target: '9',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#86efac', strokeWidth: 2 }
  },
];

function DocxConversionFlow() {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );

  return (
    <Box sx={{ height: '100vh', width: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#fafafa' }}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          m: 2,
          mb: 0,
          background: 'white',
          borderBottom: '1px solid #e5e7eb'
        }}
      >
        <Typography variant="h4" sx={{ color: '#1a1a1a', fontWeight: '600', letterSpacing: '-0.02em' }}>
          DOCX → PDF Konvertierungspipeline
        </Typography>
        <Typography variant="body2" sx={{ color: '#6b7280', mt: 1.5 }}>
          Prozessablauf für die Entwicklung der DOCX-Konvertierungspipeline
        </Typography>
        <Typography variant="caption" sx={{ color: '#9ca3af', mt: 1, display: 'block', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '11px' }}>
          Beteiligt: transcript, le-tex
        </Typography>
      </Paper>
      <Box sx={{ flexGrow: 1, m: 2, mt: 2 }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          fitView
          attributionPosition="bottom-left"
        >
          <Controls />
          <MiniMap
            nodeColor={(node) => {
              return node.style?.background || '#ffffff';
            }}
            maskColor="rgba(0, 0, 0, 0.05)"
          />
          <Background variant="dots" gap={16} size={1} color="#e5e7eb" />
        </ReactFlow>
      </Box>
    </Box>
  );
}

export default DocxConversionFlow;
